export default "__VITE_ASSET__9lX6kKB7__"